import { render, staticRenderFns } from "./ViewPropertyRates.vue?vue&type=template&id=5c2dc6da"
import script from "./ViewPropertyRates.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPropertyRates.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports